import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { adminRoutes } from "@/routes";

const router = createBrowserRouter(adminRoutes);

export function App() {
  return <RouterProvider router={router} />;
}
